import styled from "styled-components";
import { Row, Tabs } from "antd";

const Wrapper = styled.div`
	.current-step-label {
		color: #8c8c8c;
		font-size: 12px;
	}
	.title-date {
		display: flex;
		font-size: 16px;
	}
	width: 100%;
	.ant-tabs-tab:hover {
		color: #a157b0;
	}
`;
const TabsStyled = styled(Tabs)`
	.ant-tabs-tab {
		justify-content: center;
	}
	.ant-tabs-nav .ant-tabs-nav-list {
		width: ${(props) => (props.desktop ? "98%" : "")};
	}
	.ant-tabs-tab {
		width: ${(props) => (props.desktop ? "98%" : "")};
	}
	.ant-tabs-tabpane,
	.ant-tabs-tabpane-active {
		display: flex;
		flex-wrap: wrap;
		justify-content: start;
		margin: 0;
	}
	.ant-tabs-ink-bar {
		background: #a157b0;
	}
	.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
		color: #a157b0;
	}
`;

const TimeBlockButton = styled.div`
	width: 28%;
	height: 32px;
	background-color: #fafafa;
	text-align: center;
	font-weight: 500;
	margin: 8px 8px;
	padding-top: 4px;
	:hover {
		cursor: pointer;
		background-color: #fcf1ff;
		border: solid 1px #a157b0;
	}
`;

const LabelWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	width: 90px;
`;

const Icon = styled.img`
	width: 24px;
	height: auto;
	& svg:hover {
		fill: #a157b0;
	}
`;

const Label = styled.div`
	font-weight: 800;
	font-size: 12px;
`;

// https://stackoverflow.com/a/34816625/1797161
const TimeBlocksContainer = styled(Row)`
	padding-bottom: 24px;
	width: 100%;
	text-align: center;
	p {
		margin: 0;
	}
`;

export {
	Wrapper,
	TabsStyled,
	TimeBlockButton,
	LabelWrapper,
	Icon,
	Label,
	TimeBlocksContainer,
};
